// @section: footer
import { Logo } from "@/components/Brand";
import { NAV_ITEMS, CONTACT_URL } from "@/lib/site";

function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export function Footer() {
  return (
    <footer className="bg-primary text-white">
      <div className="container mx-auto px-4 md:px-6 py-14">
        <div className="grid gap-10 md:grid-cols-[1.5fr_1fr_1fr]">
          {/* @section: footer-brand */}
          <div>
            <Logo dark />
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/70">
              LINE公式アカウント連携で、接客・会員・配信を一元化するCRMソリューション。顧客一人ひとりに寄り添う体験を、組織で実現します。
            </p>
          </div>

          {/* @section: footer-nav */}
          <div>
            <h3 className="text-sm font-semibold tracking-wide text-white/90">メニュー</h3>
            <ul className="mt-4 space-y-3">
              {NAV_ITEMS.map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollToId(item.id)}
                    className="text-sm text-white/70 hover:text-accent transition-colors"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* @section: footer-cta */}
          <div>
            <h3 className="text-sm font-semibold tracking-wide text-white/90">お問い合わせ</h3>
            <p className="mt-4 text-sm text-white/70 leading-relaxed">
              導入のご相談・お見積りはお気軽にどうぞ。
            </p>
            <a
              href={CONTACT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center rounded-[4px] bg-accent px-5 py-2.5 text-sm font-semibold text-accent-foreground hover:opacity-90 transition-opacity"
            >
              お問い合わせ
            </a>
          </div>
        </div>

        <div className="mt-12 border-t border-white/15 pt-6 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <nav className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <a
              href="https://www.atiro.co.jp/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-white/70 hover:text-accent transition-colors"
            >
              プライバシーポリシー
            </a>
            <a
              href="https://www.atiro.co.jp/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-white/70 hover:text-accent transition-colors"
            >
              セキュリティポリシー
            </a>
            <a
              href="https://www.atiro.co.jp/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-white/70 hover:text-accent transition-colors"
            >
              ATIRO株式会社
            </a>
          </nav>
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()}{" "}
            <a
              href="https://www.atiro.co.jp/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-accent transition-colors"
            >
              ATIRO株式会社
            </a>{" "}
            All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
